import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

import { OrdemProducaoGeradaStruct } from '../../../../../shared/services/structs/suprimentos/ordem-producao-gerada.struct';

export interface OrdensRelacionadasDialogData {
  numeroOrigem: number;
  ordensGeradas: OrdemProducaoGeradaStruct[];
  algumFabricadoEncontrado: boolean;
}

/**
 * Resultado de "gerar ordens relacionadas" (secao 6.3 da US#141200). Aparece sempre, inclusive
 * quando nada foi gerado — nesse caso explicando que nenhum insumo fabricado foi encontrado.
 */
@Component({
  selector: 'app-ordens-relacionadas-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './ordens-relacionadas-dialog.component.html',
  styleUrls: ['./ordens-relacionadas-dialog.component.css'],
})
export class OrdensRelacionadasDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<OrdensRelacionadasDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OrdensRelacionadasDialogData,
    private router: Router,
  ) { }

  public get gerouAlguma(): boolean {
    return this.data.ordensGeradas.length > 0;
  }

  /** Fabricado existe na composição, mas as OPs filhas já tinham sido geradas antes (dedupe). */
  public get todasJaExistiam(): boolean {
    return !this.gerouAlguma && this.data.algumFabricadoEncontrado;
  }

  public abrirOrdem(idOrdemProducao: number): void {
    this.dialogRef.close();
    this.router.navigate(['/suprimentos/ordem-producao', idOrdemProducao, 'visualizar']);
  }
}
